import React from "react";
import "./PrivacyPolicy.scss";
import { IoChevronBackOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div>
      <div className="Common_header">
        <div>
          <IoChevronBackOutline
            style={{ height: "27px", width: "27px", color: "black" }}
            onClick={() => navigate("/")}
          />
        </div>
        <p className="common_header_title">Privacy Policy</p>
      </div>
      <div className="privacy-policy">
        <header className="policy-header">
          <p className="effective-date">
            Effective Date: <strong>25-12-2024</strong>
          </p>
        </header>
        <section className="policy-content">
          <p>
            We prioritize your privacy and data security. The Admin App collects
            personal and usage information to provide, improve, and secure our
            services.
          </p>

          <ul>
            <li>
              <strong>Data Collected:</strong> Personal details (e.g., name,
              email), usage data, and system information (e.g., user roles,
              reports, update metal price).
            </li>
            <li>
              <strong>Usage:</strong> For app functionality, access control,
              notifications, and analytics.
            </li>
            <li>
              <strong>Sharing:</strong> Data is not sold. It is shared only with
              service providers or for legal compliance.
            </li>
            <li>
              <strong>Security:</strong> We use encryption, access controls, and
              audits to protect your information.
            </li>
            <li>
              <strong>Your Rights:</strong> Access, update, or request deletion
              of your data by contacting support@orail.in .
            </li>
            <li>
              <strong>Retention:</strong> Data is kept as long as necessary and
              securely deleted when no longer needed.
            </li>
          </ul>

          <p>For questions, email support@orail.in.</p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
